<template>
<el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
    <el-form-item label="Selecciona un club zonal o parque" prop="idseat">
        <el-select v-model="ruleForm.idseat" placeholder="Seleccione" filterable class="w-100" @change="changeSeat">
            <el-option v-for="item in coverage" :key="item.idseat" :label="item.name" :value="item.idseat" style="width:100%;"></el-option>
        </el-select>
    </el-form-item>
    <ul v-if="seat.idseat" class="mt-4">
        <li>Ubicado en: {{seat.city}}</li>
        <li>Dirección: {{seat.address}}</li>
        <li><a href="#">Ver en el mapa</a></li>
    </ul>

    <button class="btn outline-btn mb-3 mt-3 ml-2" @click.prevent="submitForm('ruleForm')">Siguiente</button>
</el-form>
</template>

<script>
export default {
    props: {
        coverage: {
            type: Array,
            required: true,
            default: []
        }
    },
    data() {
        return {
            ruleForm: {
              idseat: null
            },
            rules: {
              idseat: [{
                    required: true,
                    message: 'Falta seleccionar',
                    trigger: ['change', 'blur']
                }]
            },
            seat: {}
        }
    },
    methods: {
        changeSeat() {
            let obj = this.coverage.filter(param => param.idseat === this.ruleForm.idseat);
            this.seat = Object.assign({}, ...obj)

        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid)
                    this.$emit("getWizard0", this.seat)
            })
        }
    }

}
</script>



// WEBPACK FOOTER //
// src/components/pages/product/wizard0.vue